/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type HeartsContainer_user$ref = any;
type HeartsDropdownContainer_user$ref = any;
type VideoEngagementContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type UserMenuContainer_user$ref: FragmentReference;
declare export opaque type UserMenuContainer_user$fragmentType: UserMenuContainer_user$ref;
export type UserMenuContainer_user = {|
  +email: ?string,
  +$fragmentRefs: HeartsContainer_user$ref & HeartsDropdownContainer_user$ref & VideoEngagementContainer_user$ref,
  +$refType: UserMenuContainer_user$ref,
|};
export type UserMenuContainer_user$data = UserMenuContainer_user;
export type UserMenuContainer_user$key = {
  +$data?: UserMenuContainer_user$data,
  +$fragmentRefs: UserMenuContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "UserMenuContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "email",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "HeartsContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "HeartsDropdownContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "VideoEngagementContainer_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a32f2616e05989ecb2abc64fa34c1741';
module.exports = node;
